import type { HNVerktoyFrontend } from '../types/Resources';

import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import { createResourcesApi, getModifiedResourcesForTest } from '@helsenorge/framework-utils/resources';

import defaultResources from './HN.Verktoy.Frontend.nb-NO.json';

export const DEFAULT_PROJECT_NAME = 'HN.Verktoy.Frontend';

const getBundledResources = (projectName: string, language: LanguageLocales): HNVerktoyFrontend | undefined => {
  if (projectName === DEFAULT_PROJECT_NAME && language === LanguageLocales.NORWEGIAN) {
    return defaultResources as unknown as HNVerktoyFrontend;
  }
};

const fetchResources = async (projectName: string, language: LanguageLocales): Promise<HNVerktoyFrontend> => {
  try {
    const resources = await import(`./${projectName}.${language}.json`);

    return resources.default;
  } catch (error) {
    throw new Error(`Failed to load resources for ${projectName} in ${language}: ${error}`);
  }
};

export const { resourcesApi, useResources } = createResourcesApi<HNVerktoyFrontend>({
  getBundledResources: getBundledResources,
  fetchResources: fetchResources,
  fallbackLanguage: LanguageLocales.NORWEGIAN,
  useFallbackForMissingTexts: true,
});

export function getResourcesTestHelper(): HNVerktoyFrontend {
  return getModifiedResourcesForTest(defaultResources) as HNVerktoyFrontend;
}
